// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"_3qfNCWyKpYkRe3PfSt_Pvj","searchIcon":"_2VPZak9MdhGYUMxrxpXCQq"};